// URL chia sẻ chuẩn SEO: /la-so/{token}/{slug} — slug chỉ để mô tả (BE sinh,
// không chứa PII), token vẫn là khoá tra cứu. Tiền tố `la-so_` (underscore) để
// KHÔNG lồng vào route /la-so/$token (route đó là leaf, không có Outlet).
import { createFileRoute } from "@tanstack/react-router";

import { SharedView } from "@/components/share/shared-view";
import { buildShareHead } from "@/lib/shared-og";
import { getSharedResource, type SharedResource } from "@/lib/boide-api";

type ShareLoaderData = { resource: SharedResource | null; token: string };

export const Route = createFileRoute("/la-so_/$token/$slug")({
  loader: async ({ params }): Promise<ShareLoaderData> => {
    try {
      const resource = await getSharedResource(params.token);
      return { resource, token: params.token };
    } catch {
      return { resource: null, token: params.token };
    }
  },
  head: ({ loaderData }) => buildShareHead(loaderData?.resource ?? null, loaderData?.token ?? ""),
  component: LaSoShareSlugPage,
});

function LaSoShareSlugPage() {
  const { resource, token } = Route.useLoaderData();
  return <SharedView resource={resource} token={token} />;
}
